// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"we_a bhi_b","TwoDimsListFeature__item":"we_b bhi_wb","TwoDimsListFeature__item__text":"we_c bhi_vr"};